// Generated by scripts/compile-patterns.mjs from web/patterns/*.not.
// Edit the .not files, then run `pnpm patterns`.
import { ratio } from "./ratio";
import type { Pattern } from "./patterns";

export const PATTERNS: Pattern[] = [
  {
    id: "adi-chatusram-2",
    name: "Adi sarvalaghu, second",
    source: "karya, Solkattu/Score/MridangamSarva.hs, kizh3, learned from Sudhindra (github.com/elaforge/karya, GPL-3.0, used with permission). Its right hand is n d _ n through the cycle, with thom under some of them; converted here as tham for thom-with-nam and \"thom+dhin\" for thom-with-din. Unverified.",
    shape: "down one two three down open down open",
    counts: ratio(8, 1),
    aksharas: 8,
    nadai: "chatusram",
    role: "variation",
    beats: 8,
    strokes: [
      { at: ratio(0, 32), stroke: "L.tham", gain: 1.12 },
      { at: ratio(1, 32), stroke: "L.dheem", gain: 1.12 },
      { at: ratio(3, 32), stroke: "L.tham", gain: 1.12 },
      { at: ratio(4, 32), stroke: "R.nam", gain: 1 },
      { at: ratio(5, 32), stroke: "L.dheem", gain: 1 },
      { at: ratio(7, 32), stroke: "L.tham", gain: 1 },
      { at: ratio(8, 32), stroke: "L.tham", gain: 1 },
      { at: ratio(9, 32), stroke: "R.dhin", gain: 1 },
      { at: ratio(11, 32), stroke: "R.nam", gain: 1 },
      { at: ratio(12, 32), stroke: "R.nam", gain: 1 },
      { at: ratio(13, 32), stroke: "R.dhin", gain: 1 },
      { at: ratio(15, 32), stroke: "R.nam", gain: 1 },
      { at: ratio(16, 32), stroke: "L.tham", gain: 1 },
      { at: ratio(17, 32), stroke: "L.dheem", gain: 1 },
      { at: ratio(19, 32), stroke: "L.tham", gain: 1 },
      { at: ratio(20, 32), stroke: "R.nam", gain: 1 },
      { at: ratio(21, 32), stroke: "L.dheem", gain: 1 },
      { at: ratio(23, 32), stroke: "L.tham", gain: 1 },
      { at: ratio(24, 32), stroke: "L.tham", gain: 1 },
      { at: ratio(25, 32), stroke: "R.dhin", gain: 1 },
      { at: ratio(27, 32), stroke: "R.nam", gain: 1 },
      { at: ratio(28, 32), stroke: "R.nam", gain: 1 },
      { at: ratio(29, 32), stroke: "R.dhin", gain: 1 },
      { at: ratio(31, 32), stroke: "R.nam", gain: 1 },
    ],
  },
  {
    id: "adi-chatusram-1",
    name: "Adi sarvalaghu, chatusram",
    source: "Transcribed stroke for stroke from a practice pattern shared with permission; where it came from is recorded privately (thambura-ext). Written in its source's stroke names. Its left-hand tha plays thom, so \"tha+num\" is tham, marked as a stand-in until the kit has the left-hand tha (#80).",
    shape: "down one two three down open down open",
    counts: ratio(8, 1),
    aksharas: 8,
    nadai: "chatusram",
    role: "main",
    beats: 8,
    strokes: [
      { at: ratio(0, 32), stroke: "L.tham", gain: 1.12, standIn: true },
      { at: ratio(4, 32), stroke: "R.dhin", gain: 1 },
      { at: ratio(8, 32), stroke: "R.dhin", gain: 1 },
      { at: ratio(12, 32), stroke: "R.dhin", gain: 1 },
      { at: ratio(16, 32), stroke: "L.tham", gain: 1, standIn: true },
      { at: ratio(18, 32), stroke: "R.nam", gain: 1 },
      { at: ratio(20, 32), stroke: "R.dhin", gain: 1 },
      { at: ratio(24, 32), stroke: "L.tham", gain: 1, standIn: true },
      { at: ratio(26, 32), stroke: "R.nam", gain: 1 },
      { at: ratio(28, 32), stroke: "R.dhin", gain: 1 },
    ],
  },
  {
    id: "adi-korvai-1",
    name: "Adi korvai",
    source: "karya, Solkattu/Score/MridangamTirmanam.hs, tir_sam_adi_kirkalam, 2022-04-23 (github.com/elaforge/karya, GPL-3.0, used with permission). Written there as tri \"D__k\" \"kookokk_\", the phrase three times with a joining D__k, and marked \"sam to sam\": it fills one cycle and resolves on the next sam. Converted here as thi for ki, thom for thom and \"thom+dhin\" for thom-with-din. Unverified by a player.",
    shape: "down one two three down open down open",
    counts: ratio(8, 1),
    aksharas: 8,
    nadai: "chatusram",
    role: "korvai",
    beats: 8,
    strokes: [
      { at: ratio(0, 32), stroke: "R.thi", gain: 1.1 },
      { at: ratio(1, 32), stroke: "L.thom", gain: 1.1 },
      { at: ratio(2, 32), stroke: "L.thom", gain: 1.1 },
      { at: ratio(3, 32), stroke: "R.thi", gain: 1.1 },
      { at: ratio(4, 32), stroke: "L.thom", gain: 1 },
      { at: ratio(5, 32), stroke: "R.thi", gain: 1 },
      { at: ratio(6, 32), stroke: "R.thi", gain: 1 },
      { at: ratio(8, 32), stroke: "L.dheem", gain: 1 },
      { at: ratio(11, 32), stroke: "R.thi", gain: 1 },
      { at: ratio(12, 32), stroke: "R.thi", gain: 1 },
      { at: ratio(13, 32), stroke: "L.thom", gain: 1 },
      { at: ratio(14, 32), stroke: "L.thom", gain: 1 },
      { at: ratio(15, 32), stroke: "R.thi", gain: 1 },
      { at: ratio(16, 32), stroke: "L.thom", gain: 1 },
      { at: ratio(17, 32), stroke: "R.thi", gain: 1 },
      { at: ratio(18, 32), stroke: "R.thi", gain: 1 },
      { at: ratio(20, 32), stroke: "L.dheem", gain: 1 },
      { at: ratio(23, 32), stroke: "R.thi", gain: 1 },
      { at: ratio(24, 32), stroke: "R.thi", gain: 1 },
      { at: ratio(25, 32), stroke: "L.thom", gain: 1 },
      { at: ratio(26, 32), stroke: "L.thom", gain: 1 },
      { at: ratio(27, 32), stroke: "R.thi", gain: 1 },
      { at: ratio(28, 32), stroke: "L.thom", gain: 1 },
      { at: ratio(29, 32), stroke: "R.thi", gain: 1 },
      { at: ratio(30, 32), stroke: "R.thi", gain: 1 },
    ],
  },
  {
    id: "khanda-chaapu-2",
    name: "Khanda Chaapu, second",
    source: "karya, Solkattu/Score/MridangamSarva.hs, kanda1, its second cycle (github.com/elaforge/karya, GPL-3.0, used with permission). Two slots to the akshara: D _ D _ N N D _ n _, converted as \"thom+dhin\", tham and nam. The first cycle plays the left-hand tha, which this kit lacks (#80), so only the second is here. Unverified.",
    shape: "down",
    counts: ratio(5, 2),
    aksharas: 5,
    nadai: "any",
    ticks: "0 2/5 3/5",
    role: "variation",
    beats: 1,
    strokes: [
      { at: ratio(0, 10), stroke: "L.dheem", gain: 1.12 },
      { at: ratio(2, 10), stroke: "L.dheem", gain: 1 },
      { at: ratio(4, 10), stroke: "L.tham", gain: 1 },
      { at: ratio(5, 10), stroke: "L.tham", gain: 1 },
      { at: ratio(6, 10), stroke: "L.dheem", gain: 1 },
      { at: ratio(8, 10), stroke: "R.nam", gain: 1 },
    ],
  },
  {
    id: "khanda-chaapu-korvai-1",
    name: "Khanda Chaapu korvai",
    source: "karya, Solkattu/Score/Solkattu2021.hs, kon_35_kanda, its first section, learned from Ganesh, 2021-02-21 (github.com/elaforge/karya, GPL-3.0, used with permission). Written there in tisram as tri tanga (tdktt_ . kp . tdktt_ . kpnp . tdktt_), with tdktt_ \"tadi_ki_ta_thom_\": the phrase three times, joined by tanga, seven cycles of Khanda Chaapu from sam to sam. karya gives it no mridangam strokes, so the realization is ours, after karya's own defaults: ta di ki ta thom as k t k n o, tanga as thom with din and ki (od _ k), and ta ka and ta ka ti ku from our phrase table, whose p is the left-hand tha, playing thom until the kit has one (#80). Unverified by a player.",
    shape: "down",
    counts: ratio(35, 2),
    aksharas: 35,
    nadai: "any",
    ticks: "0 2/5 3/5",
    role: "korvai",
    beats: 1,
    strokes: [
      { at: ratio(0, 105), stroke: "R.thi", gain: 1.1 },
      { at: ratio(1, 105), stroke: "R.ta", gain: 1.1 },
      { at: ratio(3, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(5, 105), stroke: "R.nam", gain: 1 },
      { at: ratio(7, 105), stroke: "L.thom", gain: 1 },
      { at: ratio(9, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(10, 105), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(11, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(12, 105), stroke: "R.ta", gain: 1 },
      { at: ratio(14, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(16, 105), stroke: "R.nam", gain: 1 },
      { at: ratio(18, 105), stroke: "L.thom", gain: 1 },
      { at: ratio(20, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(21, 105), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(22, 105), stroke: "R.nam", gain: 1 },
      { at: ratio(23, 105), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(24, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(25, 105), stroke: "R.ta", gain: 1 },
      { at: ratio(27, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(29, 105), stroke: "R.nam", gain: 1 },
      { at: ratio(31, 105), stroke: "L.thom", gain: 1 },
      { at: ratio(33, 105), stroke: "L.dheem", gain: 1 },
      { at: ratio(35, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(36, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(37, 105), stroke: "R.ta", gain: 1 },
      { at: ratio(39, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(41, 105), stroke: "R.nam", gain: 1 },
      { at: ratio(43, 105), stroke: "L.thom", gain: 1 },
      { at: ratio(45, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(46, 105), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(47, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(48, 105), stroke: "R.ta", gain: 1 },
      { at: ratio(50, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(52, 105), stroke: "R.nam", gain: 1 },
      { at: ratio(54, 105), stroke: "L.thom", gain: 1 },
      { at: ratio(56, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(57, 105), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(58, 105), stroke: "R.nam", gain: 1 },
      { at: ratio(59, 105), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(60, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(61, 105), stroke: "R.ta", gain: 1 },
      { at: ratio(63, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(65, 105), stroke: "R.nam", gain: 1 },
      { at: ratio(67, 105), stroke: "L.thom", gain: 1 },
      { at: ratio(69, 105), stroke: "L.dheem", gain: 1 },
      { at: ratio(71, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(72, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(73, 105), stroke: "R.ta", gain: 1 },
      { at: ratio(75, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(77, 105), stroke: "R.nam", gain: 1 },
      { at: ratio(79, 105), stroke: "L.thom", gain: 1 },
      { at: ratio(81, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(82, 105), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(83, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(84, 105), stroke: "R.ta", gain: 1 },
      { at: ratio(86, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(88, 105), stroke: "R.nam", gain: 1 },
      { at: ratio(90, 105), stroke: "L.thom", gain: 1 },
      { at: ratio(92, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(93, 105), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(94, 105), stroke: "R.nam", gain: 1 },
      { at: ratio(95, 105), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(96, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(97, 105), stroke: "R.ta", gain: 1 },
      { at: ratio(99, 105), stroke: "R.thi", gain: 1 },
      { at: ratio(101, 105), stroke: "R.nam", gain: 1 },
      { at: ratio(103, 105), stroke: "L.thom", gain: 1 },
    ],
    solkattu: [
      { at: ratio(0, 105), syllable: "ta" },
      { at: ratio(1, 105), syllable: "di" },
      { at: ratio(3, 105), syllable: "ki" },
      { at: ratio(5, 105), syllable: "ta" },
      { at: ratio(7, 105), syllable: "thom" },
      { at: ratio(9, 105), syllable: "ta" },
      { at: ratio(10, 105), syllable: "ka" },
      { at: ratio(11, 105), syllable: "ta" },
      { at: ratio(12, 105), syllable: "di" },
      { at: ratio(14, 105), syllable: "ki" },
      { at: ratio(16, 105), syllable: "ta" },
      { at: ratio(18, 105), syllable: "thom" },
      { at: ratio(20, 105), syllable: "ta" },
      { at: ratio(21, 105), syllable: "ka" },
      { at: ratio(22, 105), syllable: "ti" },
      { at: ratio(23, 105), syllable: "ku" },
      { at: ratio(24, 105), syllable: "ta" },
      { at: ratio(25, 105), syllable: "di" },
      { at: ratio(27, 105), syllable: "ki" },
      { at: ratio(29, 105), syllable: "ta" },
      { at: ratio(31, 105), syllable: "thom" },
      { at: ratio(33, 105), syllable: "tang" },
      { at: ratio(35, 105), syllable: "ga" },
      { at: ratio(36, 105), syllable: "ta" },
      { at: ratio(37, 105), syllable: "di" },
      { at: ratio(39, 105), syllable: "ki" },
      { at: ratio(41, 105), syllable: "ta" },
      { at: ratio(43, 105), syllable: "thom" },
      { at: ratio(45, 105), syllable: "ta" },
      { at: ratio(46, 105), syllable: "ka" },
      { at: ratio(47, 105), syllable: "ta" },
      { at: ratio(48, 105), syllable: "di" },
      { at: ratio(50, 105), syllable: "ki" },
      { at: ratio(52, 105), syllable: "ta" },
      { at: ratio(54, 105), syllable: "thom" },
      { at: ratio(56, 105), syllable: "ta" },
      { at: ratio(57, 105), syllable: "ka" },
      { at: ratio(58, 105), syllable: "ti" },
      { at: ratio(59, 105), syllable: "ku" },
      { at: ratio(60, 105), syllable: "ta" },
      { at: ratio(61, 105), syllable: "di" },
      { at: ratio(63, 105), syllable: "ki" },
      { at: ratio(65, 105), syllable: "ta" },
      { at: ratio(67, 105), syllable: "thom" },
      { at: ratio(69, 105), syllable: "tang" },
      { at: ratio(71, 105), syllable: "ga" },
      { at: ratio(72, 105), syllable: "ta" },
      { at: ratio(73, 105), syllable: "di" },
      { at: ratio(75, 105), syllable: "ki" },
      { at: ratio(77, 105), syllable: "ta" },
      { at: ratio(79, 105), syllable: "thom" },
      { at: ratio(81, 105), syllable: "ta" },
      { at: ratio(82, 105), syllable: "ka" },
      { at: ratio(83, 105), syllable: "ta" },
      { at: ratio(84, 105), syllable: "di" },
      { at: ratio(86, 105), syllable: "ki" },
      { at: ratio(88, 105), syllable: "ta" },
      { at: ratio(90, 105), syllable: "thom" },
      { at: ratio(92, 105), syllable: "ta" },
      { at: ratio(93, 105), syllable: "ka" },
      { at: ratio(94, 105), syllable: "ti" },
      { at: ratio(95, 105), syllable: "ku" },
      { at: ratio(96, 105), syllable: "ta" },
      { at: ratio(97, 105), syllable: "di" },
      { at: ratio(99, 105), syllable: "ki" },
      { at: ratio(101, 105), syllable: "ta" },
      { at: ratio(103, 105), syllable: "thom" },
    ],
  },
  {
    id: "khanda-chaapu-1",
    name: "Khanda Chaapu sarvalaghu",
    source: "karya, Solkattu/Score/MridangamSarva.hs, s_bhajan_kanda variation 2, the \"N,ND,\" line (youtube.com/watch?v=ctpe5H1Snd0), github.com/elaforge/karya, GPL-3.0, used with permission. Converted by us: karya's \",\" is kin, a light ki on meetu, which this kit has no take for, so it plays thi. Unverified.",
    shape: "down",
    counts: ratio(5, 2),
    aksharas: 5,
    nadai: "any",
    ticks: "0 2/5 3/5",
    role: "main",
    beats: 1,
    strokes: [
      { at: ratio(0, 5), stroke: "L.tham", gain: 1.12 },
      { at: ratio(1, 5), stroke: "R.thi", gain: 1 },
      { at: ratio(2, 5), stroke: "L.tham", gain: 1 },
      { at: ratio(3, 5), stroke: "L.dheem", gain: 1 },
      { at: ratio(4, 5), stroke: "R.thi", gain: 1 },
    ],
  },
  {
    id: "misra-chaapu-2",
    name: "Misra Chaapu, second",
    source: "karya, Solkattu/Score/MridangamSarva.hs, c_18_05_25 first line, learned from Ganesh, 2018-05-25 (github.com/elaforge/karya, GPL-3.0, used with permission). Two slots to the akshara: o k on on od _ on k od k on on od _, converted as thom, thi, tham, \"thom+dhin\". Unverified.",
    shape: "down",
    counts: ratio(7, 2),
    aksharas: 7,
    nadai: "any",
    ticks: "0 1/7 3/7 5/7",
    role: "variation",
    beats: 1,
    strokes: [
      { at: ratio(0, 14), stroke: "L.thom", gain: 1.12 },
      { at: ratio(1, 14), stroke: "R.thi", gain: 1.12 },
      { at: ratio(2, 14), stroke: "L.tham", gain: 1 },
      { at: ratio(3, 14), stroke: "L.tham", gain: 1 },
      { at: ratio(4, 14), stroke: "L.dheem", gain: 1 },
      { at: ratio(6, 14), stroke: "L.tham", gain: 1 },
      { at: ratio(7, 14), stroke: "R.thi", gain: 1 },
      { at: ratio(8, 14), stroke: "L.dheem", gain: 1 },
      { at: ratio(9, 14), stroke: "R.thi", gain: 1 },
      { at: ratio(10, 14), stroke: "L.tham", gain: 1 },
      { at: ratio(11, 14), stroke: "L.tham", gain: 1 },
      { at: ratio(12, 14), stroke: "L.dheem", gain: 1 },
    ],
  },
  {
    id: "misra-chaapu-korvai-1",
    name: "Misra Chaapu korvai",
    source: "karya, Solkattu/Score/Mridangam2018.hs, tir_18_06_15, learned from Ganesh, 2018-06-15 (github.com/elaforge/karya, GPL-3.0, used with permission). A tirmanam written there as tri (od.__) (t.k.o.o.k.o.o.k): the phrase three times, joined by thom with din. It fills one cycle and resolves on the next sam. Converted as ta, thi for ki, thom, and \"thom+dhin\". Unverified by a player.",
    shape: "down",
    counts: ratio(7, 2),
    aksharas: 7,
    nadai: "any",
    ticks: "0 1/7 3/7 5/7",
    role: "korvai",
    beats: 1,
    strokes: [
      { at: ratio(0, 28), stroke: "R.ta", gain: 1.1 },
      { at: ratio(1, 28), stroke: "R.thi", gain: 1.1 },
      { at: ratio(2, 28), stroke: "L.thom", gain: 1.1 },
      { at: ratio(3, 28), stroke: "L.thom", gain: 1.1 },
      { at: ratio(4, 28), stroke: "R.thi", gain: 1 },
      { at: ratio(5, 28), stroke: "L.thom", gain: 1 },
      { at: ratio(6, 28), stroke: "L.thom", gain: 1 },
      { at: ratio(7, 28), stroke: "R.thi", gain: 1 },
      { at: ratio(8, 28), stroke: "L.dheem", gain: 1 },
      { at: ratio(10, 28), stroke: "R.ta", gain: 1 },
      { at: ratio(11, 28), stroke: "R.thi", gain: 1 },
      { at: ratio(12, 28), stroke: "L.thom", gain: 1 },
      { at: ratio(13, 28), stroke: "L.thom", gain: 1 },
      { at: ratio(14, 28), stroke: "R.thi", gain: 1 },
      { at: ratio(15, 28), stroke: "L.thom", gain: 1 },
      { at: ratio(16, 28), stroke: "L.thom", gain: 1 },
      { at: ratio(17, 28), stroke: "R.thi", gain: 1 },
      { at: ratio(18, 28), stroke: "L.dheem", gain: 1 },
      { at: ratio(20, 28), stroke: "R.ta", gain: 1 },
      { at: ratio(21, 28), stroke: "R.thi", gain: 1 },
      { at: ratio(22, 28), stroke: "L.thom", gain: 1 },
      { at: ratio(23, 28), stroke: "L.thom", gain: 1 },
      { at: ratio(24, 28), stroke: "R.thi", gain: 1 },
      { at: ratio(25, 28), stroke: "L.thom", gain: 1 },
      { at: ratio(26, 28), stroke: "L.thom", gain: 1 },
      { at: ratio(27, 28), stroke: "R.thi", gain: 1 },
    ],
  },
  {
    id: "misra-chaapu-1",
    name: "Misra Chaapu sarvalaghu",
    source: "karya, Solkattu/Score/MridangamSarva.hs, kir_misra_2, learned from Ganesh, 2017-09-26 (github.com/elaforge/karya, GPL-3.0, used with permission). Converted by us: karya's N is thom with nam, D is thom with din, and this kit plays those as tham and \"thom+dhin\". The mapping is ours and unverified.",
    shape: "down",
    counts: ratio(7, 2),
    aksharas: 7,
    nadai: "any",
    ticks: "0 1/7 3/7 5/7",
    role: "main",
    beats: 1,
    strokes: [
      { at: ratio(0, 7), stroke: "L.tham", gain: 1.12 },
      { at: ratio(1, 7), stroke: "L.dheem", gain: 1 },
      { at: ratio(2, 7), stroke: "L.tham", gain: 1 },
      { at: ratio(3, 7), stroke: "L.tham", gain: 1 },
      { at: ratio(7, 14), stroke: "L.tham", gain: 1 },
      { at: ratio(4, 7), stroke: "L.dheem", gain: 1 },
      { at: ratio(5, 7), stroke: "L.dheem", gain: 1 },
      { at: ratio(6, 7), stroke: "L.tham", gain: 1 },
    ],
  },
  {
    id: "rupakam-chatusram-2",
    name: "Short Rupakam sarvalaghu, second",
    source: "karya, Solkattu/Score/MridangamSarva.hs, rupaka1, the first cycle of its second line (github.com/elaforge/karya, GPL-3.0, used with permission). \"N_D_nkn_d___\" converted by us: N is thom with nam (tham), D is thom with din (\"thom+dhin\"), n is nam, k is ki (thi), d is din. Unverified by a player.",
    shape: "down down open",
    counts: ratio(3, 1),
    aksharas: 3,
    nadai: "chatusram",
    role: "variation",
    beats: 3,
    strokes: [
      { at: ratio(0, 12), stroke: "L.tham", gain: 1.12 },
      { at: ratio(2, 12), stroke: "L.dheem", gain: 1.12 },
      { at: ratio(4, 12), stroke: "R.nam", gain: 1 },
      { at: ratio(5, 12), stroke: "R.thi", gain: 1 },
      { at: ratio(6, 12), stroke: "R.nam", gain: 1 },
      { at: ratio(8, 12), stroke: "R.dhin", gain: 1 },
    ],
  },
  {
    id: "rupakam-chatusram-1",
    name: "Short Rupakam sarvalaghu, chatusram",
    source: "karya, Solkattu/Score/MridangamSarva.hs, s_rupaka first line, 2026-02-05 (github.com/elaforge/karya, GPL-3.0, used with permission). \"D_oknoD_D_N_\" converted by us: D is thom with din (\"thom+dhin\" here), N is thom with nam (tham), k is ki (thi). Unverified by a player.",
    shape: "down down open",
    counts: ratio(3, 1),
    aksharas: 3,
    nadai: "chatusram",
    role: "main",
    beats: 3,
    strokes: [
      { at: ratio(0, 12), stroke: "L.dheem", gain: 1.12 },
      { at: ratio(2, 12), stroke: "L.thom", gain: 1.12 },
      { at: ratio(3, 12), stroke: "R.thi", gain: 1.12 },
      { at: ratio(4, 12), stroke: "R.nam", gain: 1 },
      { at: ratio(5, 12), stroke: "L.thom", gain: 1 },
      { at: ratio(6, 12), stroke: "L.dheem", gain: 1 },
      { at: ratio(8, 12), stroke: "L.dheem", gain: 1 },
      { at: ratio(10, 12), stroke: "L.tham", gain: 1 },
    ],
  },
  {
    id: "rupakam-korvai-1",
    name: "Short Rupakam korvai",
    source: "karya, Solkattu/Score/MridangamTirmanam.hs, tir_icarnatic_guhan_kamalakiran_rupaka, 2023-03-10 (github.com/elaforge/karya, GPL-3.0, used with permission). Written there as tri \"D_o\" (su \"ktpkpktp ktpkpk\" . \"DDk\"): the phrase three times, joined by thom with din and thom, three cycles of Short Rupakam from sam to sam. Converted as thi for k, ta for t, \"thom+dhin\" for D and thom for o; its p is the left-hand tha, which plays thom until the kit has one (#80). Unverified by a player.",
    shape: "down down open",
    counts: ratio(9, 1),
    aksharas: 9,
    nadai: "chatusram",
    role: "korvai",
    beats: 3,
    strokes: [
      { at: ratio(0, 72), stroke: "R.thi", gain: 1.1 },
      { at: ratio(1, 72), stroke: "R.ta", gain: 1.1 },
      { at: ratio(2, 72), stroke: "L.thom", gain: 1.1, standIn: true },
      { at: ratio(3, 72), stroke: "R.thi", gain: 1.1 },
      { at: ratio(4, 72), stroke: "L.thom", gain: 1.1, standIn: true },
      { at: ratio(5, 72), stroke: "R.thi", gain: 1.1 },
      { at: ratio(6, 72), stroke: "R.ta", gain: 1.1 },
      { at: ratio(7, 72), stroke: "L.thom", gain: 1.1, standIn: true },
      { at: ratio(8, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(9, 72), stroke: "R.ta", gain: 1 },
      { at: ratio(10, 72), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(11, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(12, 72), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(13, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(14, 72), stroke: "L.dheem", gain: 1 },
      { at: ratio(16, 72), stroke: "L.dheem", gain: 1 },
      { at: ratio(18, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(20, 72), stroke: "L.dheem", gain: 1 },
      { at: ratio(24, 72), stroke: "L.thom", gain: 1 },
      { at: ratio(26, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(27, 72), stroke: "R.ta", gain: 1 },
      { at: ratio(28, 72), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(29, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(30, 72), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(31, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(32, 72), stroke: "R.ta", gain: 1 },
      { at: ratio(33, 72), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(34, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(35, 72), stroke: "R.ta", gain: 1 },
      { at: ratio(36, 72), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(37, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(38, 72), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(39, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(40, 72), stroke: "L.dheem", gain: 1 },
      { at: ratio(42, 72), stroke: "L.dheem", gain: 1 },
      { at: ratio(44, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(46, 72), stroke: "L.dheem", gain: 1 },
      { at: ratio(50, 72), stroke: "L.thom", gain: 1 },
      { at: ratio(52, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(53, 72), stroke: "R.ta", gain: 1 },
      { at: ratio(54, 72), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(55, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(56, 72), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(57, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(58, 72), stroke: "R.ta", gain: 1 },
      { at: ratio(59, 72), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(60, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(61, 72), stroke: "R.ta", gain: 1 },
      { at: ratio(62, 72), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(63, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(64, 72), stroke: "L.thom", gain: 1, standIn: true },
      { at: ratio(65, 72), stroke: "R.thi", gain: 1 },
      { at: ratio(66, 72), stroke: "L.dheem", gain: 1 },
      { at: ratio(68, 72), stroke: "L.dheem", gain: 1 },
      { at: ratio(70, 72), stroke: "R.thi", gain: 1 },
    ],
  },
];
